import { RevisionListView, RevisionShowView } from '@/views/authenticated/revisions';

export default [
  {
    path: '/districts/:district/plans/:plan/revisions',
    name: 'app_revision_list',
    component: RevisionListView,
    meta: { redirectAuthenticatedUsers: false, requiresAuthentication: true },
  },
  {
    path: '/districts/:district/plans/:plan/revisions/:revision',
    name: 'app_revision_show',
    component: RevisionShowView,
    meta: { redirectAuthenticatedUsers: false, requiresAuthentication: true },
  },
];
